import { parseTenantList } from "@utils/tenant";

const APP_NAME = import.meta.env.VITE_NAME ?? import.meta.env.REACT_APP_NAME;
const ENV = import.meta.env.VITE_ENVIRONMENT ?? import.meta.env.REACT_APP_ENVIRONMENT;
const IDENTITY_URL = import.meta.env.VITE_IDENTITY_API ?? import.meta.env.REACT_APP_IDENTITY_API;

/** Multitenancy prerequisite, preserving the existing deployment flag precedence. */
const HAS_MULTITENANT =
  (import.meta.env.VITE_HAS_MULTITENANT ?? import.meta.env.REACT_APP_HAS_MULTITENANT) === "true";

/**
 * Enables Identity for every tenant, independently of the agents chat setting, unless
 * VITE_IDENTITY_TENANTS lists specific tenants.
 */
const USE_IDENTITY = import.meta.env.VITE_USE_IDENTITY === "true";

/**
 * Tenants that use Identity, by their code in the URL without the environment suffix. When it
 * lists any, it decides over VITE_USE_IDENTITY.
 */
const IDENTITY_TENANTS = parseTenantList(import.meta.env.VITE_IDENTITY_TENANTS);

const DEBUG = Boolean(import.meta.env.VITE_DEBUG ?? import.meta.env.REACT_APP_DEBUG);

const DEFAULT_MESSAGES = {
  ERROR: "Ha ocurrido un error. Inténtalo nuevamente",
};

export {
  APP_NAME,
  ENV,
  IDENTITY_URL,
  HAS_MULTITENANT,
  USE_IDENTITY,
  IDENTITY_TENANTS,
  DEBUG,
  DEFAULT_MESSAGES,
};
